import { withoutConnectMarkers } from './connectMarkers';

/**
 * The `returnTo` of the mailbox connect (F20-i Wave-1 contract `ConnectStartQuery`, § Redirect Contract):
 * the CRM page the user is on, as a relative path plus its query string — no fragment, and without the two
 * marker parameters, so the page the flow returns to never carries a stale marker.
 *
 * At most 2,048 characters: over the cap the path alone, and over it again no `returnTo` at all, which
 * the backend reads as `/` (F20-i WI-1.3 plan D-13). The length is measured on the encoded text, which is
 * never shorter than the decoded text the backend measures, so the cap is never crossed. The backend
 * re-validates whatever arrives; this only keeps the client from sending something it would refuse.
 */
export const RETURN_TO_MAX_LENGTH = 2048;

/** The parts of a location the return path reads — `window.location` in the app. */
export interface ReturnLocation {
    readonly pathname: string;
    readonly search: string;
}

export function connectReturnPath(location: ReturnLocation = window.location): string | undefined {
    const query = withoutConnectMarkers(new URLSearchParams(location.search)).toString();
    const full = query === '' ? location.pathname : `${location.pathname}?${query}`;
    if (full.length <= RETURN_TO_MAX_LENGTH) {
        return full;
    }
    return location.pathname.length <= RETURN_TO_MAX_LENGTH ? location.pathname : undefined;
}
